// eslint-disable-next-line @typescript-eslint/ban-ts-comment
//@ts-nocheck

import "./_organization-chart.scss";

export default function OrganizationChart() {
    const $wrapper = document.querySelector('.organization-chart');

    if ($wrapper) {
        const $modal = $wrapper.querySelector('.wrapper-modal') as HTMLDivElement;
        const $singleCards = $wrapper.querySelectorAll('.wrap-card');
        const $icnClose = $wrapper.querySelector('.close-icn') as HTMLDivElement;
        const $mask = $wrapper.querySelector('.mask') as HTMLDivElement;
        const dataJson = $wrapper.querySelector('#organizational_chart')as HTMLScriptElement;
        const wrapperValues = $wrapper.querySelector('.wrap-values') as HTMLDivElement;
        const $wrapChart = $wrapper.querySelector('.wrap-chart');
        let data: any;

        dataJson && (data = JSON.parse(dataJson.innerHTML));

        function createBox(data) {
            const box = document.createElement('div');
            box.classList.add('box');
            box.setAttribute('id', `${data.id}`);
            box.setAttribute('data-father', `${data.pid}`);
            box.setAttribute('data-position', `${data.position}`);


            const imageDiv = document.createElement('div');
            imageDiv.classList.add('image');
            const image = document.createElement('img');
            image.src = data.img;
            image.alt = data.name;
            image.title = data.title;
            imageDiv.appendChild(image);

            const wrapInfo = document.createElement('div');
            wrapInfo.classList.add('wrap-info');

            const title = document.createElement('div');
            title.classList.add('title');
            title.textContent = data.name;
            wrapInfo.appendChild(title);

            const description = document.createElement('div');
            description.classList.add('description');
            description.textContent = data.title;
            wrapInfo.appendChild(description);

            if(data.img != null) {
                box.appendChild(imageDiv);
            }
            box.appendChild(wrapInfo);
            return box;
        }

        function createLink(number) {
            const link = document.createElement('div');
            link.classList.add(`link`);
            link.classList.add(`${number}`);

            for (let i = 0; i < 3; i++) {
                const cell = document.createElement('div');
                cell.classList.add('cell');
                link.appendChild(cell);
            }

            $wrapChart.appendChild(link);
        }

        function createStructure(data, parent) {
            const box = createBox(data);
            parent.appendChild(box);

            if (data.children && data.children.length > 0) {
                data.children.length === 3 ? createLink('center-three') : data.children.length === 2 ? createLink('center-two') : createLink();

                const row = document.createElement('div');
                row.classList.add('row');
                $wrapChart.appendChild(row);

                data.children.forEach(child => {
                    row.setAttribute('data-position', child.position);
                    const correspondingRow = $wrapper.querySelector(`[data-position="${child.position}"]`);

                    if(correspondingRow) {
                        createStructure(child, correspondingRow);
                    }
                })
            }

        }

        data.forEach(item => {
            const row = document.createElement('div');
            row.classList.add('row');
            $wrapChart.appendChild(row);

            createStructure(item, row);
        })

        const rows = $wrapChart.querySelectorAll('.row');
        rows.forEach(row => {
            const boxElements = row.querySelectorAll('.box');
            if (boxElements.length === 2) {
                const dataFatherValues = Array.from(boxElements).map(box => {
                    return box.getAttribute('data-father');
                })

                if(dataFatherValues[0] !== dataFatherValues[1]) {
                    const linkElement = row.previousElementSibling;
                    if (linkElement && linkElement.classList.contains('link')) {
                        const lastBoxId = boxElements[boxElements.length - 1].getAttribute('data-father');
                        const secondBoxParentId = boxElements[1].getAttribute('data-father');
                        const firstBoxId = boxElements[0].getAttribute('data-father');
                        const firstBoxParentId = boxElements[0].getAttribute('data-father');

                        const previousRow = linkElement.previousElementSibling;
                        const previousBoxes = Array.from(previousRow.querySelectorAll('.box'));

                        const findLastBox = previousBoxes.find(box => box.id === lastBoxId)
                        const findFirstBox = previousBoxes.find(box => box.id === firstBoxId)
                        const positionLastBox = previousBoxes.indexOf(findLastBox);
                        const positionFirstBox = previousBoxes.indexOf(findFirstBox);

                        if (lastBoxId === secondBoxParentId && positionLastBox === 2) {
                            const emptyBox = document.createElement('div');
                            emptyBox.classList.add('empty-box');
                            const emptySecondBox = document.createElement('div');
                            emptySecondBox.classList.add('empty-second-box');

                            row.insertBefore(emptyBox, boxElements[0]);
                            row.insertBefore(emptySecondBox, boxElements[0]);

                            linkElement.classList.add('right-one');
                        }

                        if (firstBoxParentId === firstBoxId && positionFirstBox === 0) {
                            linkElement.classList.add('left-one');
                        }
                    }
                }
            }

            if(boxElements.length === 3) {
                const dataFatherValues = Array.from(boxElements).map(box => {
                    return box.getAttribute('data-father');
                })

                if(dataFatherValues[0] !== dataFatherValues[1] && dataFatherValues[0] !== dataFatherValues[2] && dataFatherValues[2] !== dataFatherValues[1]) {
                    const linkElement = row.previousElementSibling;
                    if (linkElement && linkElement.classList.contains('link')) {
                        linkElement.classList.add('right-one');
                        linkElement.classList.add('left-one');
                    }
                }


            }
        })

        function removeDuplicateRows() {
            const rows = $wrapChart.querySelectorAll('.row');
            const positionMap = {};

            rows.forEach(row => {
                const position = row.getAttribute('data-position');
                if (positionMap[position]) {
                    const linkElement = row.previousElementSibling;
                    row.parentNode.removeChild(row);

                    if (linkElement && linkElement.classList.contains('link')) {
                        linkElement.parentNode.removeChild(linkElement)
                    }
                } else {
                    positionMap[position] = true;
                }
            });
        }

        function createModalKeyValues(data: any) {
            if(data['key-value_list'].length) {
                data['key-value_list'].forEach(item => {
                    const wrapValue = document.createElement('div');
                    wrapValue.classList.add('wrap-value');
                    const key = document.createElement('div');
                    key.classList.add('label');
                    key.innerText = item.key;
                    const value = document.createElement('div');
                    value.classList.add('value');
                    value.innerText = item.value;

                    wrapValue.appendChild(key);
                    wrapValue.appendChild(value);
                    wrapperValues.appendChild(wrapValue);
                })
            }
        }

        function ui() {
            $icnClose.addEventListener('click', () => {
                closeModal();
            })

            if($mask) {
                $mask.addEventListener('click', () => {
                    closeModal();

                    $singleCards.forEach(($card: any) => {
                        closeModalSingleCard($card);
                    })
                })
            }

            document.addEventListener('keydown', (e => {
                if(e.key === "Escape") {
                    closeModal();

                    $singleCards.forEach(($card: any) => {
                        closeModalSingleCard($card);
                    })
                }
            }))

            $singleCards.forEach(($card: any) => {
                const $closeBtn = $card.querySelector('.close-icn');
                const $img = $card.querySelector('img') as HTMLImageElement;

                if($img && $img.getAttribute('src') === '') {
                    $img?.parentElement?.classList.add('d-none');
                }

                $card.addEventListener('click', function() {
                    openModalSingleCard($card);
                });

                $closeBtn.addEventListener('click', function(event) {
                    event.stopPropagation();
                    closeModalSingleCard($card);
                });
            })

            openModal()
        }

        function closeModal() {
            $modal.classList.add('d-none');
            $modal.removeAttribute('id');
            $mask.classList.add('d-none');
            document.body.style.overflow = 'scroll';
            const $wrapValue = $modal.querySelectorAll('.wrap-value');

            $wrapValue.length && $wrapValue.forEach($wrap => {
                $wrap.remove()
            })
        }

        function findElementById(root, targetId) {
            if (root.id === targetId) {
                return root;
            }

            if (root.children && root.children.length > 0) {
                const results = root.children.map(child => findElementById(child, targetId)).filter(result => result !== null);
                if (results.length > 0) {
                    return results[0];
                }
            }
            return null;
        }

        function openModal() {
            const $boxes = $wrapChart.querySelectorAll('.box');
            const $avatarImg = $modal.querySelector('.avatar') as HTMLDivElement;
            const $name = $modal.querySelector('.title') as HTMLDivElement;
            const $description = $modal.querySelector('.description') as HTMLDivElement;
            const $info = $modal.querySelector('.info') as HTMLDivElement;

            $boxes.forEach($box => {
                $box.addEventListener('click', () => {
                    const boxId = $box.getAttribute('id');
                    $modal.classList.remove('d-none');
                    $mask.classList.remove('d-none');
                    document.body.style.overflow = 'hidden';
                    $modal.setAttribute('id', `${boxId}`);
                    const findId = findElementById(data[0], boxId);

                    if(findId) {
                        $avatarImg.setAttribute('src', findId.img);
                        $name.innerHTML = findId.name;
                        $description.innerHTML = findId.title;
                        $info.innerHTML = findId.desc;
                        createModalKeyValues(findId)
                    }
                })
            })
        }

        function openModalSingleCard(card) {
            const $modal = card.querySelector('.wrapper-modal.single-card');
            const $mask = document.querySelector('.mask');

            $modal.classList.remove('d-none');
            $mask.classList.remove('d-none');
            document.body.style.overflow = 'hidden';
        }

        function closeModalSingleCard(card) {
            const $modal = card.querySelector('.wrapper-modal.single-card');
            const $mask = document.querySelector('.mask');

            $modal.classList.add('d-none');
            $mask.classList.add('d-none');
            document.body.style.overflow = 'scroll';
        }

        removeDuplicateRows();
        ui();
    }
}
